<template>
  <div>

   <b-card header="Add new Outlet" v-if="view=='Outlet'"> 
   <b-row>
    <b-col sm="4">
    <p id="FormText">Outlet ID</p>
    </b-col>
    <b-col sm="8">
    <input
     type="text"
     placeholder="Outlet ID"
     v-model="newOutlet.ID"
     required
     @focus="modal = false"
     />
    </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
    <p id="FormText">Outlet Type</p>
    </b-col>
    <b-col sm="8">
    <b-form-select v-model="newOutlet.Type">
      <option selected null disabled>Select Outlet Type</option>
      <option value="Cold Tap">Cold Tap</option>
      <option value="Hot Tap">Hot Tap</option>
      <option value="Mixed Tap">Mixed Tap</option>
      <option value="Shower">Shower</option>
      <option value="TMV">TMV/Mixing Valve</option>
      <option value="Other">Other</option>
    </b-form-select>
  </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
    <p id="FormText">Outlet Feed</p>
    </b-col>
    <b-col sm="8">
    <b-form-select v-model="newOutlet.Feed">
      <option selected null disabled>Select Outlet Feed</option>
      <option value="Cold Feed">Cold Feed</option>
      <option value="Hot Feed">Hot Feed</option>
      <option value="Mixed Feed">Mixed Feed</option>
      <option value="Return">Return</option>
    </b-form-select>
  </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
    <p id="FormText">Outlet Location</p>
     </b-col>
     <b-col sm="8">
     <input
     type="text"
     :placeholder=this.selectedlocation
     readonly
     @focus="modal = false"
     /> 
     </b-col>
     </b-row>
     <b-row>
    <b-col sm="4">
    <p id="FormText">Outlet Area</p>
    </b-col>
    <b-col sm="8">
    <input
     type="text"
     placeholder="Room/Area of Outlet"
     v-model="newOutlet.DeptFloor"
     required
     @focus="modal = false"
     />
    </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
    <p id="FormText">Outlet Position</p>
    </b-col>
    <b-col sm="8">
      <b-form-select v-model="newOutlet.Position" :options="this.positionslist"></b-form-select>
    </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
    <p id="FormText">Position Note</p>
    </b-col>
    <b-col sm="8">
    <input
     type="text"
     placeholder="Note on Position"
     v-model="newOutlet.LocationNote"
     required
     @focus="modal = false"
     />
    </b-col>
    </b-row>
    <b-row>
    <b-col sm="4">
    <p id="FormText">Sentinel Outlet</p>
    </b-col>
    <b-col sm="8">
      <b-form-select v-model="newOutlet.Sentinel">
      <option selected null disabled>Sentinel Outlet</option>
      <option value="TRUE">YES</option>
      <option value="FALSE">NO</option>
    </b-form-select>
    </b-col>
    </b-row>
    <br />
    <b-row>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="SubmitNewForm('Outlet')"
                              >
                                Submit
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="CancelNewForm('Outlet')"

                              >
                                Cancel
                              </b-button>
                            </b-col>
                          </b-row>
   </b-card>
   <br />
   <b-card header="Add new C-1 Device" v-if="view=='C1'">
    <b-row>
      <b-col>Add new Clarence C-1 Form Goes here</b-col>
   </b-row>
   <br />
    <b-row>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="SubmitNewForm('C1')"
                              >
                                Submit
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="CancelNewForm('C1')"

                              >
                                Cancel
                              </b-button>
                            </b-col>
                          </b-row>
   </b-card>
   <br />
   <b-card header="Add new O-1 Device" v-if="view=='O1'">
    <b-row>
     <b-col>add new Clarence O-1 Form Goes here</b-col>
   </b-row>
   <br />
    <b-row>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="SubmitNewForm('O1')"
                              >
                                Submit
                              </b-button>
                            </b-col>
                            <b-col>
                              <b-button
                                variant="outline-info"
                                v-on:click="CancelNewForm('O1')"

                              >
                                Cancel
                              </b-button>
                            </b-col>
                          </b-row>
   </b-card>
  </div>
</template>

    
    <script>
  
   import axios from "axios";

    
    
    
    export default {

      props:['view'],
      
      
      computed: {
    
      },
      components: {

      },
    
      data() {
      return {

        newOutlet:{
          ID:"",
          Type: "",
          Feed: "",
          Location: "",
          DeptFloor: "",
          Position: "",
          LocationNote: "",
          Sentinel: ""
        },
        selectedlocation: localStorage.getItem("CurrentLocation"),
        PositionArray:[],
        positionslist: []

        };
      },
    
    
      beforeMount() {
    
      
    
          
        },
    
    
    
      mounted(){
      
        let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/lookup";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      RequestType: "Positions",
    };

    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {

         let PositionArray = response.data.Positions

         for (let i = 0; i < PositionArray.length; i++) {


          this.positionslist.push({
            value: PositionArray[i],
            text: PositionArray[i]
          })

        }

       });


  
              
    
      }, 
    
     
      methods: {

        SubmitNewForm(type){

          if(type=='Outlet'){
          
            if(this.newOutlet.ID == "" || this.newOutlet.Type == "" || this.newOutlet.Feed == "" || this.newOutlet.DeptFloor == "" ||
              this.newOutlet.Position == "" || this.newOutlet.Sentinel == "" ){
              alert('Please complete all fields')
            }

            else{

          let PostUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/outlets";
    let PostHeaders = this.$apikeyPost;
    this.PostRequest = {
      RequestType: "AddOutlet",
      DataDict:[{
        OutletID: this.newOutlet.ID,
        OutletType: this.newOutlet.Type,
        OutletFeed: this.newOutlet.Feed,
        Location: this.selectedlocation,
        DeptFloor: this.newOutlet.DeptFloor,
        Position: this.newOutlet.Position,
        LocationNote: this.newOutlet.LocationNote,
        Sentinel: this.newOutlet.Sentinel

    }]
    };

    axios
      .post(PostUrl, this.PostRequest, PostHeaders)
      .then((response) => {
        response
        alert('Outlet added to system')
        this.newOutlet = {}
        this.$emit("event-name", type);

       });
          }
        }

          if(type=='C1'){
            alert('C1 submit')
            this.$emit("event-name", type);
          }

          if(type=='O1'){
            alert('O1 submit')
            this.$emit("event-name", type);
          }
          

        },
        CancelNewForm(type){

          if(type=='Outlet'){
            this.newOutlet = {}
            this.$emit("event-name", type);
          }

          if(type=='C1'){
            alert('C1 clear')
            this.$emit("event-name", type);
          }

          if(type=='O1'){
            alert('O1 clear')
            this.$emit("event-name", type);
          }
  
        },
      
       
    

  }}
    </script>
    
    <style>
    
    input[type="text"], select {
    width: 100%;
    padding: 5px 5px 5px 5px;
    border: solid 1px rgba(200, 200, 200, 0.5);
    background-color: rgb(245, 245, 245);
}

    </style>
    

 



